import React from 'react'
import axios from "axios"
import { useSearchParams } from 'react-router-dom'
import { enqueueSnackbar } from "notistack";
import { BsStripe } from "react-icons/bs";
import { useNavigate } from 'react-router-dom';
import Loader from '../../utils/Loader';

import { useStripe, useElements, CardNumberElement, CardExpiryElement, CardCvcElement } from '@stripe/react-stripe-js';

import { hostNameBack } from '../../utils/constants';
import { states } from '../../utils/constants';

import countries from "../../utils/countries.json"
import { AuthContext } from '../../utils/AuthContext'
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';

function Checkout() {

  const token = localStorage.getItem("token");
  const [searchParams] = useSearchParams();

  const [items, setItems] = React.useState(null);
  const [summary, setSummary] = React.useState({ paidByBuyer: { totalSalesPrice: 0, totalShipping: 0, commission: 0, subtotal: 0, tax: 0, total: 0, promoDiscount: 0 } });

  const [serviceItem, setServiceItem] = React.useState(null);
  const [serviceSummary, setServiceSummary] = React.useState({
    paidByBuyer: { salesPrice: 0, commission: 0, tax: 0, total: 0, promoDiscount: 0 },
    sellerToGet: { salesPrice: 0, commission: 0, total: 0 }
  });

  const [customItem, setCustomItem] = React.useState(null);

  const [paymentMethod, setPaymentMethod] = React.useState("stripe");

  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = React.useState(false);
  const [isAvailable, setIsAvailable] = React.useState(true);

  const navigate = useNavigate();

  const [couponCode, setCouponCode] = React.useState('');
  const [appliedCoupon, setAppliedCoupon] = React.useState(null);

  const [billingInfo, setBillingInfo] = React.useState({
    firstName: "",
    lastName: "",
    address: "",
    country: "",
    state: "",
    city: "",
    zipCode: "",
    email: "",
    phoneNumber: "",
    note: "",
    stateTax: 5
  });

  const [useBillingAsShipping, setUseBillingAsShipping] = React.useState(true);
  const [shippingInfo, setShippingInfo] = React.useState({
    firstName: "",
    lastName: "",
    address: "",
    country: "",
    state: "",
    city: "",
    zipCode: "",
  });

  const [feesObj, setFeesObj] = React.useState({
    seller: { product: 0, service: 0 },
    paidSeller: { product: 0, service: 0 },
    buyer: { product: 0, service: 0 }
  });

  const { user } = React.useContext(AuthContext)
  const [isFetchingUserData, setIsFetchingUserData] = React.useState(true)
  const [hidePaymentDetails, setHidePaymentDetails] = React.useState(false);

  React.useEffect(() => {

    axios.get(`${hostNameBack}/api/v1/settings/admin/feesAndMembership`)
      .then(response => {
        if (response.data.success)
          setFeesObj(response.data.fees);
      })
  }, [])

  React.useEffect(() => {
    if (!user) {
      setIsFetchingUserData(false)
      return
    }
    const splitName = user?.sellerId?.fullName ? user?.sellerId?.fullName.split(' ') : []
    setBillingInfo(prev => ({
      ...prev,
      firstName: splitName[0] || "",
      lastName: splitName.slice(1).join(' ') || "",
      country: user?.sellerId?.country || "",
      state: user?.sellerId?.state || "",
      address: user.address || "",
      city: user.city || "",
      zipCode: user.zipCode || "",
      email: user.email || "",
      phoneNumber: user.phoneNumber || ""
    }))
    setIsFetchingUserData(false);
  }, [user])

  React.useEffect(() => {

    const fromCart = searchParams.get("cart") === "true";
    const productId = searchParams.get("p");
    const serviceId = searchParams.get("s");
    const messageId = searchParams.get("c");

    if (fromCart) {
      axios.get(`${hostNameBack}/api/v1/carts`, { headers: { Authorization: `Bearer ${token}` } })
        .then(response => {
          if (response.data.success) {
            const isAvailable = response.data.cart.products.every(item => item.product.sellerId.isAvailable);
            setIsAvailable(isAvailable);
            setItems(response.data.cart.products);
            updateSummary(response.data.cart.products);
          }
        })
      // .catch(e => {
      //   enqueueSnackbar(e.response?.data?.error || "Something went wrong!", { variant: "error" });
      // })
    }
    else if (productId) {

      const id = productId.split("_")[0];
      const count = productId.split("_")[1];

      axios.get(`${hostNameBack}/api/v1/products/product/${id}`)
        .then(response => {
          if (response.data.success) {
            if(!response.data.product.sellerId.isAvailable)
              setIsAvailable(false);
            const item = {
              product: response.data.product,
              count: count
            }
            setItems([item]);
            updateSummary([item]);
          }
        })

      // .catch(e => {
      //   enqueueSnackbar(e?.response?.data?.error || "Something went wrong!", { variant: "error" });
      // })
    }
    else if (serviceId) {

      const pkgIndex = serviceId.split("_")[0];
      const id = serviceId.split("_")[1];

      axios.get(`${hostNameBack}/api/v1/services/service/${id}`)
        .then(response => {
          if (response.data.success) {
            if(!response.data.service.sellerId.isAvailable)
              setIsAvailable(false);
            const service = { service: response.data.service, pkgIndex: Number(pkgIndex) };
            setServiceItem(service);
            updateServiceSummary(service);
          }
        })
      // .catch(e => {
      //   enqueueSnackbar(e?.response?.data?.error || "Something went wrong!", { variant: "error" });
      // })
    }
    else if (messageId) {
      axios.get(`${hostNameBack}/api/v1/chats/offer/details/${messageId}`, { headers: { Authorization: `Bearer ${token}` } })
        .then(response => {
          if (response.data.success) {
            const offer = response.data.offer;
            if (offer.quoteType === "product")
              updateCustomSummary(offer);
            else
              updateServiceCustomSummary(offer);
            setCustomItem(offer);
          }
        })
      // .catch(e => {
      //   enqueueSnackbar(e?.response?.data?.error || "Something went wrong!", { variant: "error" });
      // })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams, token, feesObj]);


  const updateSummary = (products, couponDiscount, stateTax) => {

    let paidByBuyer = { totalSalesPrice: 0, totalShipping: 0, commission: 0, subtotal: 0, tax: 0, total: 0, promoDiscount: 0 };

    products.forEach(item => {

      const myItem = item.product;
      const count = item.count;

      paidByBuyer.totalSalesPrice += myItem.salesPrice * count;
      paidByBuyer.totalShipping += parseFloat(myItem.shippingFees);
    });

    if (couponDiscount) {
      paidByBuyer.totalSalesPrice -= (paidByBuyer.totalSalesPrice * Number(couponDiscount || appliedCoupon.discount) / 100)
      paidByBuyer.promoDiscount = couponDiscount || appliedCoupon.discount;
    }

    paidByBuyer.commission = (paidByBuyer.totalSalesPrice + paidByBuyer.totalShipping) * (Number(feesObj.buyer.product) / 100);

    paidByBuyer.subtotal = paidByBuyer.totalSalesPrice + paidByBuyer.totalShipping + paidByBuyer.commission;

    paidByBuyer.tax = paidByBuyer.subtotal * ((stateTax || billingInfo.stateTax) / 100);

    paidByBuyer.total = paidByBuyer.subtotal + paidByBuyer.tax;

    setSummary({ paidByBuyer });
  };

  const updateServiceSummary = (serviceItem, couponDiscount, stateTax) => {

    const pkg = serviceItem.service.packages[serviceItem.pkgIndex];

    let paidByBuyer = { salesPrice: 0, commission: 0, tax: 0, total: 0 };
    let sellerToGet = { salesPrice: 0, commission: 0, total: 0 }

    paidByBuyer.salesPrice = pkg.salesPrice;
    sellerToGet.salesPrice = pkg.salesPrice;

    if (couponDiscount) {
      paidByBuyer.salesPrice -= (paidByBuyer.salesPrice * Number(couponDiscount || appliedCoupon.discount) / 100)
      paidByBuyer.promoDiscount = couponDiscount || appliedCoupon.discount;
    }

    paidByBuyer.commission = paidByBuyer.salesPrice * (Number(feesObj?.buyer?.service) / 100);
    sellerToGet.commission = sellerToGet.salesPrice * (serviceItem.service.sellerId?.sellerType === "Free" ? (Number(feesObj?.seller?.service) / 100) : (Number(feesObj?.paidSeller?.service) / 100));

    paidByBuyer.tax = (paidByBuyer.salesPrice + paidByBuyer.commission) * ((stateTax || billingInfo.stateTax) / 100)

    paidByBuyer.total = paidByBuyer.salesPrice + paidByBuyer.commission + paidByBuyer.tax;
    sellerToGet.total = sellerToGet.salesPrice - sellerToGet.commission;

    setServiceSummary({ paidByBuyer, sellerToGet });
  }

  const updateCustomSummary = (offer, couponDiscount, stateTax) => {

    let paidByBuyer = { totalSalesPrice: 0, totalShipping: 0, commission: 0, subtotal: 0, tax: 0, total: 0, promoDiscount: 0 };

    paidByBuyer.totalSalesPrice = offer.offerAmount;

    if (couponDiscount) {
      paidByBuyer.totalSalesPrice -= (paidByBuyer.totalSalesPrice * Number(couponDiscount || appliedCoupon.discount) / 100)
      paidByBuyer.promoDiscount = couponDiscount || appliedCoupon.discount;
    }

    paidByBuyer.totalShipping += parseFloat(offer.shippingFee);

    paidByBuyer.commission = (paidByBuyer.totalSalesPrice + paidByBuyer.totalShipping) * (Number(feesObj?.buyer?.product) / 100);

    paidByBuyer.subtotal = paidByBuyer.totalSalesPrice + paidByBuyer.totalShipping + paidByBuyer.commission;

    paidByBuyer.tax = paidByBuyer.subtotal * ((stateTax || billingInfo.stateTax) / 100);

    paidByBuyer.total = paidByBuyer.subtotal + paidByBuyer.tax;

    setSummary({ paidByBuyer });
  };

  const updateServiceCustomSummary = (offer, couponDiscount, stateTax) => {

    let paidByBuyer = { salesPrice: 0, commission: 0, tax: 0, total: 0 };
    let sellerToGet = { salesPrice: 0, commission: 0, total: 0 }

    paidByBuyer.salesPrice = offer.offerAmount;
    sellerToGet.salesPrice = offer.offerAmount;

    if (couponDiscount) {
      paidByBuyer.salesPrice -= (paidByBuyer.salesPrice * Number(couponDiscount || appliedCoupon.discount) / 100)
      paidByBuyer.promoDiscount = couponDiscount || appliedCoupon.discount;
    }

    paidByBuyer.commission = paidByBuyer.salesPrice * (Number(feesObj?.buyer?.service) / 100);
    sellerToGet.commission = sellerToGet.salesPrice * (offer.serviceId.sellerId?.sellerType === "Free" ? (Number(feesObj?.seller?.service) / 100) : (Number(feesObj?.paidSeller?.service) / 100));

    paidByBuyer.tax = (paidByBuyer.salesPrice + paidByBuyer.commission) * ((stateTax || billingInfo.stateTax) / 100);

    paidByBuyer.total = paidByBuyer.salesPrice + paidByBuyer.commission + paidByBuyer.tax;
    sellerToGet.total = sellerToGet.salesPrice - sellerToGet.commission;

    setServiceSummary({ paidByBuyer, sellerToGet });
  }

  const handlePlaceOrder = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!stripe || !elements) {
      return;
    }

    const cardElement = elements.getElement(CardNumberElement);

    const { error, paymentMethod } = await stripe.createPaymentMethod({
      type: 'card',
      card: cardElement,
    });

    if (error) {
      enqueueSnackbar(error.message, { variant: 'error' });
      setLoading(false);
      return;
    }

    let convertedItem = null;
    if (customItem) {
      if (customItem.quoteType === "product") {
        convertedItem = [{
          product: customItem.productId,
          count: customItem.quantity
        }]
        convertedItem[0].product.salesPrice = summary.paidByBuyer.totalSalesPrice;
        convertedItem[0].product.shippingFees = summary.paidByBuyer.totalShipping;
      }
      else if (customItem.quoteType === "service") {
        convertedItem = {
          pkg: {
            name: "CUSTOM",
            title: customItem.title,
            description: customItem.description,
            deliveryDays: customItem.duration
          },
          service: customItem.serviceId,
        }
      }
    }

    summary.paidByBuyer.taxPercent = billingInfo.stateTax;
    serviceSummary.paidByBuyer.taxPercent = billingInfo.stateTax;

    const shippingAddress = useBillingAsShipping
      ? {
        firstName: billingInfo.firstName,
        lastName: billingInfo.lastName,
        address: billingInfo.address,
        country: billingInfo.country,
        state: billingInfo.state,
        city: billingInfo.city,
        zipCode: billingInfo.zipCode,
      }
      : shippingInfo;

    const orderData = {
      items: items || serviceItem || convertedItem,
      summary: (items || (customItem && customItem.quoteType === "product")) ? summary : serviceSummary,
      paymentMethod: 'stripe',
      billingInfo,
      shippingAddress: (items || (customItem && customItem.quoteType === "product")) ? shippingAddress : undefined,
      offerId: customItem ? customItem.offerId : null
    };

    try {
      const { data } = await axios.post(`${hostNameBack}/api/v1/orders/${(items || (customItem && customItem.quoteType === "product")) ? "product" : "service"}/order`, orderData, {
        headers: { Authorization: `Bearer ${token}` }
      });

      const clientSecret = data.clientSecret;

      const { paymentIntent, error: stripeError } = await stripe.confirmCardPayment(clientSecret, {
        payment_method: paymentMethod.id
      });

      if (stripeError) {
        enqueueSnackbar(stripeError.message, { variant: 'error' });
        setLoading(false);
        return;
      }

      if (paymentIntent.status === 'succeeded') {
        enqueueSnackbar("Order placed successfully!", { variant: 'success' });
        navigate(`${(items || (customItem && customItem.quoteType === "product")) ? "/orders" : "/requirements/" + data.order._id}`)
        setLoading(false);
      }
    } catch (e) {
      enqueueSnackbar(e?.response?.data?.error || "Something went wrong!", { variant: 'error' });
      setLoading(false);
    }
  };

  const handleChange = (e) => {

    const { name, value } = e.target;

    if (name === "country") {

      setBillingInfo(prevState => ({
        ...prevState,
        state: "",
        stateTax: 5
      }));
      if (items)
        updateSummary(items, appliedCoupon?.discount, 5);
      else if (serviceItem)
        updateServiceSummary(serviceItem, appliedCoupon?.discount, 5);
      else if (customItem) {
        if (customItem.quoteType === "product")
          updateCustomSummary(customItem, appliedCoupon?.discount, 5);
        else if (customItem.quoteType === "service")
          updateServiceCustomSummary(customItem, appliedCoupon?.discount, 5);
      }

    }

    if (name === "state") {
      const selectedState = states.find(state => state.name === value);
      const stateTax = selectedState ? selectedState.tax : 5;
      setBillingInfo({
        ...billingInfo,
        stateTax
      });
      if (items)
        updateSummary(items, appliedCoupon?.discount, stateTax);
      else if (serviceItem)
        updateServiceSummary(serviceItem, appliedCoupon?.discount, stateTax);
      else if (customItem) {
        if (customItem.quoteType === "product")
          updateCustomSummary(customItem, appliedCoupon?.discount, stateTax);
        else if (customItem.quoteType === "service")
          updateServiceCustomSummary(customItem, appliedCoupon?.discount, stateTax);
      }

    }

    setBillingInfo(prevState => ({
      ...prevState,
      [name]: value
    }));

  };

  const handleCouponClick = () => {

    if (appliedCoupon) {
      setAppliedCoupon(null);
      setCouponCode('');

      if (items)
        updateSummary(items);
      else if (serviceItem)
        updateServiceSummary(serviceItem);
      else if (customItem) {
        if (customItem.quoteType === "product")
          updateCustomSummary(customItem);
        else if (customItem.quoteType === "service")
          updateServiceCustomSummary(customItem);
      }

      enqueueSnackbar("Coupon removed!", { variant: "info" });
    }
    else {
      axios.post(`${hostNameBack}/api/v1/coupons/apply`, { code: couponCode, salesPrice: (items || (customItem && customItem.quoteType === "product")) ? summary.paidByBuyer.totalSalesPrice.toFixed(2) : serviceSummary.paidByBuyer.salesPrice.toFixed(2) }, {
        headers: { Authorization: `Bearer ${token}` }
      })
        .then(response => {
          if (response.data.success) {
            const coupon = response.data.coupon;
            setAppliedCoupon(coupon);

            if (items)
              updateSummary(items, coupon.discount);
            else if (serviceItem)
              updateServiceSummary(serviceItem, coupon.discount);
            else if (customItem) {
              if (customItem.quoteType === "product")
                updateCustomSummary(customItem, coupon.discount);
              else if (customItem.quoteType === "service")
                updateServiceCustomSummary(customItem, coupon.discount);
            }

            enqueueSnackbar("Coupon Applied!", { variant: "success" });
          }
        })
        .catch(e => {
          enqueueSnackbar(e.response?.data?.error || "Invalid coupon code!", { variant: "error" });
        });
    }
  };

  const itemElems = items ? items.map((item, index) => {

    let myItem = item.product;
    let count = item.count;

    return <div key={index} className="item">
      <div className="imgDiv">
        <img src={`${myItem.productImages ? myItem.productImages[0] : ""}`} alt="Product Thumbnail" />
      </div>
      <div className="itemContent">
        <p className='singleLineText'>{myItem.title}</p>
        <p className='price'>{count} x ${myItem.salesPrice}</p>
      </div>
    </div>
  }) : "Nothing to show here"

  const serviceElem = serviceItem ? <div className="item">
    <div className="imgDiv">
      <img src={`${serviceItem.service?.serviceImages[0]}`} alt="Service Thumbnail" />
    </div>
    <div className="itemContent">
      <p className='singleLineText'>{serviceItem.service.title}</p>
      <p className='price'>{serviceItem.service.packages[serviceItem.pkgIndex].name} - ${serviceItem.service.packages[serviceItem.pkgIndex].salesPrice}</p>
    </div>
  </div>
    : "Nothing to show here"

  const customElem = customItem ? <div className="item">
    <div className="imgDiv">
      <img src={`${customItem.productId ? customItem.productId.productImages[0] : customItem.serviceId.serviceImages[0]}`} alt="Thumbnail" />
    </div>
    <div className="itemContent">
      <p className='singleLineText'>{customItem.title}</p>
      {customItem.quoteType === "product" && <p className='price'>Quantity: {customItem.quantity}</p>}
      {customItem.quoteType === "service" && <p className='price'>CUSTOM - ${customItem.offerAmount}</p>}
    </div>
  </div>
    : "Nothing to show here"


  if (isFetchingUserData || (!items && !serviceItem && !customItem)) return <Loader type="simple" />

  return (
    <div className='checkoutDiv'>
      <section className="section">
        <div className="checkoutContent">

          <div className="billingInfo form">

            <div className="billingInfoUpper">
              <h2 className="secondaryHeading"><span>{(items || (customItem && customItem.quoteType === "product")) ? "Billing" : "Buyer"}</span> Info</h2>
            </div>

            <div className="inputDiv">
              <div className="inputInnerDiv">
                <label>First Name</label>
                <input type="text" className='inputField' placeholder='Enter First Name' name="firstName" value={billingInfo.firstName} onChange={handleChange} />
              </div>
              <div className="inputInnerDiv">
                <label>Last Name</label>
                <input type="text" className='inputField' placeholder='Enter Last Name' name="lastName" value={billingInfo.lastName} onChange={handleChange} />
              </div>
            </div>

            <div className="inputDiv">
              <div className="inputInnerDiv">
                <label>Country</label>
                <select className="inputField dropdownLight" name='country' value={billingInfo.country} onChange={handleChange}>
                  {!billingInfo.country && <option value="">Select Country</option>}
                  {countries.map((country) => (
                    <option key={country.name} value={country.name}>{country.name}</option>
                  ))}
                </select>
              </div>
              {billingInfo.country === "Canada" ? <div className="inputInnerDiv">
                <label>State/Region</label>
                <select className="inputField dropdownLight" name='state' onChange={handleChange} value={billingInfo.state} disabled={!billingInfo.country}>
                  {!billingInfo.state && <option value="">Select State/Region</option>}
                  {states.map((state, index) => (
                    <option key={index} value={state.name}>{state.name}</option>
                  ))}
                </select>
              </div>
                :
                <div className="inputInnerDiv">
                  <label>Province/State</label>
                  <input type="text" className='inputField' placeholder='Enter State' value={billingInfo.state} name="state" onChange={handleChange} />
                </div>}
            </div>

            {(items || (customItem && customItem.quoteType === "product")) && <><div className="inputDiv">
              <label>Address</label>
              <textarea className='inputField' placeholder='Enter Address' value={billingInfo.address} name="address" onChange={handleChange} />
            </div>

              <div className="inputDiv">
                <div className="inputInnerDiv">
                  <label>City</label>
                  <input type="text" className='inputField' placeholder='Enter your City' value={billingInfo.city} name="city" onChange={handleChange} />
                </div>
                <div className="inputInnerDiv">
                  <label>Zip Code</label>
                  <input type="text" className='inputField' placeholder='Enter Zip Code' name="zipCode" value={billingInfo.zipCode} onChange={handleChange} />
                </div>
              </div></>}

            <div className="inputDiv">
              <div className="inputInnerDiv">
                <label>Email</label>
                <input type="email" className='inputField' placeholder='Enter Email' name="email" value={billingInfo.email} onChange={handleChange} />
              </div>
              <div className="inputInnerDiv">
                <label>Phone Number</label>
                <input type="Number" className='inputField' placeholder='Enter Phone Number' name="phoneNumber" value={billingInfo.phoneNumber} onChange={handleChange} />
              </div>
            </div>

            {(items || (customItem && customItem.quoteType === "product")) && <>
              <div className="horizontalLine"></div>
              <h2 className="secondaryHeading">Shipping Address</h2>
              <div className="checkboxDiv">
                <input
                  type="checkbox"
                  className='checkbox'
                  name="useBillingAsShipping"
                  id="useBillingAsShipping"
                  checked={useBillingAsShipping}
                  onChange={() => setUseBillingAsShipping(!useBillingAsShipping)}
                />
                <label htmlFor="useBillingAsShipping">Same as Billing Address</label>
              </div>
              {!useBillingAsShipping && (
                <>
                  <div className="inputDiv">
                    <div className="inputInnerDiv">
                      <label>First Name</label>
                      <input type="text" className='inputField' placeholder='Enter First Name' name="firstName" value={shippingInfo.firstName} onChange={(e) => setShippingInfo({ ...shippingInfo, firstName: e.target.value })} />
                    </div>
                    <div className="inputInnerDiv">
                      <label>Last Name</label>
                      <input type="text" className='inputField' placeholder='Enter Last Name' name="lastName" value={shippingInfo.lastName} onChange={(e) => setShippingInfo({ ...shippingInfo, lastName: e.target.value })} />
                    </div>
                  </div>
                  <div className="inputDiv">
                    <label>Country</label>
                    <select
                      className="inputField dropdownLight"
                      name="country"
                      value={shippingInfo.country}
                      onChange={(e) => setShippingInfo({ ...shippingInfo, country: e.target.value })}
                    >
                      <option value="">Select Country</option>
                      {countries.map((country) => (
                        <option key={country.name} value={country.name}>
                          {country.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  {shippingInfo.country === "Canada" ? (
                    <div className="inputDiv">
                      <label>State/Region</label>
                      <select
                        className="inputField dropdownLight"
                        name="state"
                        value={shippingInfo.state}
                        onChange={(e) => setShippingInfo({ ...shippingInfo, state: e.target.value })}
                      >
                        <option value="">Select State/Region</option>
                        {states.map((state, index) => (
                          <option key={index} value={state.name}>
                            {state.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  ) : (
                    <div className="inputDiv">
                      <label>Province/State</label>
                      <input
                        type="text"
                        className="inputField"
                        placeholder="Enter State"
                        value={shippingInfo.state}
                        onChange={(e) => setShippingInfo({ ...shippingInfo, state: e.target.value })}
                      />
                    </div>
                  )}
                  <div className="inputDiv">
                    <label>Address</label>
                    <textarea
                      className="inputField"
                      placeholder="Enter Address"
                      value={shippingInfo.address}
                      onChange={(e) => setShippingInfo({ ...shippingInfo, address: e.target.value })}
                    />
                  </div>
                  <div className="inputDiv">
                    <div className="inputInnerDiv">
                      <label>City</label>
                      <input
                        type="text"
                        className="inputField"
                        placeholder="Enter your City"
                        value={shippingInfo.city}
                        onChange={(e) => setShippingInfo({ ...shippingInfo, city: e.target.value })}
                      />
                    </div>
                    <div className="inputInnerDiv">
                      <label>Zip Code</label>
                      <input
                        type="text"
                        className="inputField"
                        placeholder="Enter Zip Code"
                        value={shippingInfo.zipCode}
                        onChange={(e) => setShippingInfo({ ...shippingInfo, zipCode: e.target.value })}
                      />
                    </div>
                  </div>
                </>
              )}
            </>}

            <div className="horizontalLine"></div>

            <div className="paymentMethodsDiv">
              <h2 className="secondaryHeading"><span>Payment</span> Method</h2>

              <div className="paymentOptions">
                <div className={`stripe paymentOption ${paymentMethod === 'stripe' ? 'selected' : ''}`} onClick={() => setPaymentMethod('stripe')}><BsStripe className='icon' /><div>Stripe</div></div>
              </div>

              {paymentMethod === "stripe" && (
                <>
                  <div className='hidePaymentInfo'>
                    <div className='upper' onClick={() => setHidePaymentDetails(!hidePaymentDetails)}>
                      {hidePaymentDetails ? "Show Card Info" : "Hide Card Info"}
                      {!hidePaymentDetails ? <MdKeyboardArrowUp className='icon' /> : <MdKeyboardArrowDown className='icon' />}
                    </div>
                  </div>
                  <div style={{
                    maxHeight: hidePaymentDetails ? '0' : '500px',
                    opacity: hidePaymentDetails ? 0 : 1,
                    overflow: 'hidden',
                    transition: 'max-height 0.5s ease, opacity 0.5s ease',
                    pointerEvents: hidePaymentDetails ? 'none' : 'auto'
                  }}>
                    <form className='form'>
                      <div className="inputDiv">
                        <label>Card Number</label>
                        <CardNumberElement className="inputField" />
                      </div>
                      <div className="inputDiv">
                        <div className="inputInnerDiv">
                          <label>Expiry Date</label>
                          <CardExpiryElement className="inputField" />
                        </div>
                        <div className="inputInnerDiv">
                          <label>CVC</label>
                          <CardCvcElement className="inputField" />
                        </div>
                      </div>
                    </form>
                  </div>
                </>
              )}

            </div>

            {(items || (customItem && customItem.quoteType === "product")) && <><div className="horizontalLine"></div>

              <div className="inputDiv">
                <label>Any Special Note? (optional)</label>
                <textarea className='inputField' placeholder='Enter note for delivery' name="note" onChange={handleChange} />
              </div></>}
          </div>

          <div className="orderSummary">

            <h2 className="secondaryHeading"><span>Order</span> Summary</h2>

            <div className="horizontalLine"></div>

            {items ? itemElems : serviceItem ? serviceElem : customElem}

            <div className="horizontalLine"></div>

            <div className='row'>
              <p>Sales Price</p>
              <strong>${(items || (customItem && customItem.quoteType === "product")) ? summary.paidByBuyer.totalSalesPrice.toFixed(2) : serviceSummary.paidByBuyer.salesPrice.toFixed(2)}</strong>
            </div>

            <div className="inputDiv promoCodeBox">
              <input
                type="text"
                className='inputField'
                placeholder='Enter Promo Code'
                value={couponCode}
                onChange={(e) => setCouponCode(e.target.value)}
                disabled={appliedCoupon}
              />
              <button className='secondaryBtn' disabled={!couponCode} onClick={handleCouponClick}>{appliedCoupon ? "Remove" : "Apply"}</button>
            </div>

            {appliedCoupon && <div className='row'>
              <p>Coupon Applied</p>
              <strong>{appliedCoupon.discount}% Discount</strong>
            </div>}

            <div className='row'>
              <p>{(items || (customItem && customItem.quoteType === "product")) ? "Shipping Fee" : `Service Fee (${feesObj?.buyer?.service}%)`}</p>
              <strong>${(items || (customItem && customItem.quoteType === "product")) ? summary.paidByBuyer.totalShipping.toFixed(2) : serviceSummary.paidByBuyer.commission.toFixed(2)}</strong>
            </div>

            {(items || (customItem && customItem.quoteType === "product")) && <> <div className='row'>
              <p>Service Fee ({feesObj?.buyer?.product}%)</p>
              <strong>${summary.paidByBuyer.commission.toFixed(2)}</strong>
            </div>
              <div className='row'>
                <p>SubTotal</p>
                <strong>${summary.paidByBuyer.subtotal.toFixed(2)}</strong>
              </div>

            </>}

            <div className="horizontalLine"></div>

            <div className='row'>
              <p>Tax ({billingInfo.stateTax + "%"})</p>
              <strong className='tax'>${(items || (customItem && customItem.quoteType === "product")) ? summary.paidByBuyer.tax.toFixed(2) : serviceSummary.paidByBuyer.tax.toFixed(2)}</strong>
            </div>

            <div className='row'>
              <p>Total</p>
              <strong className='subTotal'>${(items || (customItem && customItem.quoteType === "product")) ? summary.paidByBuyer.total.toFixed(2) : serviceSummary.paidByBuyer.total.toFixed(2)}</strong>
            </div>

            {!(items || (customItem && customItem.quoteType === "product")) && <div className='row'>
              <p>Delivery Time</p>
              <strong>{serviceItem ? serviceItem.service.packages[serviceItem.pkgIndex].deliveryDays : customItem.duration} days</strong>
            </div>}

            {!isAvailable && <p className="infoText" style={{color: "var(--warning)"}}>Sellers of some of your selected provisions are partially not available for work so you can't make a purchase.</p>}

            <button className='primaryBtn' disabled={!stripe || loading || !isAvailable} type="submit" onClick={handlePlaceOrder}>
              {loading ? "Processing..." : `Pay $${(items || (customItem && customItem.quoteType === "product")) ? summary.paidByBuyer.total.toFixed(2) : serviceSummary.paidByBuyer.total.toFixed(2)}`}
            </button>

          </div>

        </div>
      </section>
    </div>
  )
}

export default Checkout